import KeymapEntry from '../keymap-entry'

import basicsSvg from './segment-icons/basics-svg.vue'
import heatingSvg from './segment-icons/heating-svg.vue'
import renewablesSvg from './segment-icons/renewables-svg.vue'
import roofSvg from './segment-icons/roof-svg.vue'
import wallsAndFloorSvg from './segment-icons/walls-and-floor-svg.vue'
import windowsAndDoorsSvg from './segment-icons/windows-and-doors-svg.vue'


/**
 * Maps provided API keys for segments to images and / or icons to display.
 * @type {KeymapEntry[]}
 */
const keymap = [
    new KeymapEntry('basics', 'Basics', { svg: basicsSvg }),
    new KeymapEntry('roof', 'Roof', { svg: roofSvg }),
    new KeymapEntry('walls-and-floor', 'Walls & Floor', { svg: wallsAndFloorSvg }),
    new KeymapEntry('windows-and-doors', 'Windows & Doors', { svg: windowsAndDoorsSvg, buttonText: 'Windows' }),
    new KeymapEntry('heating', 'Heating', { svg: heatingSvg }),
    new KeymapEntry('renewables', 'Renewables', { svg: renewablesSvg }),
    new KeymapEntry('other', 'Others', { faIcon: 'lightbulb' }),
]

export default keymap
